module.exports = __webpack_public_path__ + "img/productsblur.7b833a17.jpg";